import {
    GET_PEDIDOS_SUCCESS,
    GET_PEDIDOS_FAIL
} from './types'
import * as requestsApi from '../../api/requests';

//GET PEDIDOS POR USUARIO
export const get_pedidos = (params) => async dispatch => {
    if (localStorage.getItem('access')) {
        try {
            const res = await requestsApi.getMyRequests(params);
            if (res.status === 200) {
                dispatch({
                    type: GET_PEDIDOS_SUCCESS,
                    payload: res.data
                });
            } else {

                dispatch({
                    type: GET_PEDIDOS_FAIL
                });
            }
        } catch (err) {
            dispatch({
                type: GET_PEDIDOS_FAIL
            });
        }
    }
}
